module.exports = __webpack_public_path__ + "static/media/editar.4e4fbb46.svg";